import { CRUDEntity } from "../abstracts/CRUDEntity";

export class QuickbooksIntegrationHistoryAdmin extends CRUDEntity {
    constructor(id=null){
        super();
        this.entityClass = 'quickbooks-sync-admin-historie';
        this.urlRoot = '/admin/organization-management/quickbooks-sync-list';
        this.sectionRootUrl = '/admin/organization-management/quickbooks-sync-list';
        this.id = id;
    }
}